<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="calibre_pb_0"></div>
<p class="calibre3"><span id="pgepubid00045" title="[35]"><a id="Page_35" title="[35]"></a></span></p>
<h2 class="calibre" id="pgepubid00046">CHAPTER IV.<br class="calibre16"/>
<span class="cheaderfont">A SON OF THE GODS.</span></h2>
<p class="pcalibre drop-capi-m">ON the day but one following the reading of Paul
Romanoff’s secret will, Olga and Serge set out for
St. Petersburg, to convey his ashes to their last
resting-place in the Cathedral of SS. Peter and
Paul in the Fortress of Petropaulovski, where
reposed the dust of the Tyrants of Russia, from Peter the Great
to Alexander <span class="smcap">II.</span> of Russia, now only remembered as the
chief characters in the dark tragedy of the days before the
Revolution.</p>
<p class="calibre3">The intense love of the Russians for their country had
survived the tremendous change that had passed over the
face of society, and it was still the custom to bring the ashes
of those who claimed noble descent and deposit them in one
of their national churches, even when they had died in distant
countries.</p>
<p class="calibre3">The station from which they started was a splendid structure
of marble, glass, and aluminium steel, standing in the
midst of a vast, abundantly-wooded garden, which occupied
the region that had once been made hideous by the slums and
sweating-dens of Southwark. The ground floor was occupied
by waiting-rooms, dining-saloons, conservatories, and winter-gardens,
for the convenience and enjoyment of travellers; and
from these lifts rose to the upper storey, where the platforms
and lines lay under an immense crystal arch.</p>
<p class="calibre3">Twelve lines ran out of the station, divided into three sets<span id="pgepubid00047" title="[36]"><a id="Page_36" title="[36]"></a></span>
of four each. Of these, the centre set was entirely devoted to
continental traffic, and the lines of this system stretched without
a break from London to Pekin.</p>
<p class="calibre3">The cars ran suspended on a single rail upheld by light,
graceful arches of a practically unbreakable alloy of aluminium,
steel, and zinc, while about a fifth of their weight was borne by
another single insulating rail of forged glass,—the rediscovery
of the lost art of making which had opened up immense possibilities
to the engineers of the twenty-first century.</p>
<p class="calibre3">Along this lower line the train ran, not on wheels, but on
lubricated bearings, which glided over it with no more friction
than that of a steel skate on ice. On the upper rail ran
double-flanged wheels with ball-bearings, and this line also
conducted the electric current from which the motive-power
was derived.</p>
<p class="calibre3">The two inner lines of each set were devoted to long-distance,
express traffic, and the two outer to intermediate
transit, corresponding to the ordinary trains of the present
day. Thus, for example, the train by which Olga and Serge
were about to travel, stopped only at Brussels, Berlin, Königsberg,
Moscow, Nijni Novgorod, Tomsk, Tobolsk, Irkutsk, and
Pekin, which was reached by a line running through the
Salenga valley and across the great desert of Shamoo, while
from Irkutsk another branch of the line ran north-eastward
viâ Yakutsk to the East Cape, where the Behring Bridge united
the systems of the Old World and the New.</p>
<p class="calibre3">The usual speed of the expresses was a hundred and fifty
miles an hour, rising to two hundred on the long runs; and that
of the ordinary trains, from a hundred to a hundred and fifty.
Higher speeds could of course be attained on emergencies, but
these had been found to be quite sufficient for all practical
purposes.</p>
<p class="calibre3">The cars were not unlike the Pullmans of the present day,
save that they were wider and roomier, and were built not of
wood and iron, but of aluminium and forged glass. Their
interiors were, of course, absolutely impervious to wind and
dust, even at the highest speed of the train, although a<span id="pgepubid00048" title="[37]"><a id="Page_37" title="[37]"></a></span>
perfect system of ventilation kept their atmosphere perfectly
fresh.</p>
<p class="calibre3">The long-distance trains were fitted up exactly as moving
hotels, and the traveller, from London to Pekin or Montreal,
was not under the slightest necessity of leaving the train,
unless he chose to do so, from end to end of the journey.</p>
<p class="calibre3">One more advantage of railway travelling in the twenty-first
century may be mentioned here. It was entirely free,
both for passengers and baggage. Easy and rapid transit
being considered an absolute necessity of a high state of
civilisation, just as armies and navies had once been thought
to be, every self-supporting person paid a small travelling tax,
in return for which he or she was entitled to the freedom of all
the lines in the area of the Federation.</p>
<p class="calibre3">In addition to this tax, the municipality of every city or
town through which the lines passed, set apart a portion of
their rent-tax for the maintenance of the railways, in return
for the advantages they derived from them.</p>
<p class="calibre3">Under this reasonable condition of affairs, therefore, all that
an intending traveller had to do was to signify the date of his
departure and his destination to the superintendent of the
nearest station, and send his heavier baggage on in advance by
one of the trains devoted to the carriage of freight. A place
was then allotted to him, and all he had to do was to go and
take possession of it.</p>
<p class="calibre3">The Continental Station was comfortably full of passengers
when Olga and Serge reached it, about fifteen minutes before
the departure of the Eastern express; for people were leaving
the Capital of the World in thousands just then, to spend
Christmas and New Year with friends in the other cities of
Europe, and especially to attend the great Winter Festival that
was held every year in St. Petersburg in celebration of the
anniversary of Russian freedom.</p>
<p class="calibre3">Ten minutes before the express started, they ascended in
one of the lifts to the platform, and went to find their seats.
As they walked along the train, Olga suddenly stopped and
said, almost with a gasp—</p>
<p class="calibre3"><span id="pgepubid00049" title="[38]"><a id="Page_38" title="[38]"></a></span></p>
<p class="calibre3">“Look, Serge! There are two Aerians, and one of them
is”—</p>
<p class="calibre3">“Who?” said Serge, almost roughly. “I didn’t know you
had any acquaintances among the Masters of the World.”</p>
<p class="calibre3">The son of the Romanoffs hated the very name of the
Aerians, so bitterly that even the mere suspicion that his
idolised betrothed should have so much as spoken to one of
them was enough to rouse his anger.</p>
<p class="calibre3">“No, I haven’t,” she replied quietly, ignoring the sudden
change in his manner; “but both you and I have very good
reason for wishing to make their distinguished acquaintance.
I recognise one of these because he sat beside Alan Arnold, the
President of the Council, in St. Paul’s, when they were foolish
enough to relinquish the throne of the world in obedience to
an old man’s whim.</p>
<p class="calibre3">“The taller of the two standing there by the pillar is the
younger counterpart of the President, and if his looks don’t
belie him, he can be no one but the son of Alan Arnold, and
therefore the future ruler of Aeria, and the present or future
possessor of the Great Secret. Do you see now why it is
necessary that we should—well, I will say, make friends of
those two handsome lads?”</p>
<p class="calibre3">Olga spoke rapidly and in Russian, a tongue then scarcely
ever heard and very little understood even among educated
people, who, whatever their nationality, made English their
language of general intercourse. The words “handsome lads”
had grated harshly upon Serge’s ears, but he saw the force of
Olga’s question at once, and strove hard to stifle the waking
demon of jealousy that had been roused more by her tone and
the quick bright flush on her cheek than by her words, as he
answered—</p>
<p class="calibre3">“Forgive me, darling, for speaking roughly! Their hundred
years of peace have not tamed my Russian blood enough to let
me look upon my enemies without anger. Of course, you are
right; and if they are going by the express, as they seem to
be, we should be friendly enough by the time we reach
Königsberg.”</p>
<p class="calibre3"><span id="pgepubid00050" title="[39]"><a id="Page_39" title="[39]"></a></span></p>
<p class="calibre3">“I am glad you agree with me,” said Olga, “for the destinies
of the world may turn on the events of the next few hours.
Ah, the Fates are kind! Look! There is Alderman<a id="FNanchor_2_2"></a><span class="fnanchor" href="#/Text/Section0039#Footnote_2_2" title="Link target outside of Sample">[2]</span> Heatherstone
talking to them. I suppose he has come to see them off,
for no doubt they have been the guests of the City during
the Festival. Come, he will very soon make us known to
each other.”</p>
<p class="calibre3">A couple of minutes later the Alderman, who had been an
old friend of Paul Ivanitch, the famous sculptor, had cordially
greeted them and introduced them to the two Aerians, whose
names he gave as Alan Arnoldson, the son of the President of
the late Supreme Council, and Alexis Masarov, a descendant
of the Alexis Mazanoff who had played such a conspicuous
part in the war of the Terror. They were just starting on the
tour of the world, and were bound for St. Petersburg to witness
the Winter Festival.</p>
<p class="calibre3">Olga had been more than justified in speaking of them as
she had done. Both in face and form, they were the very ideal
of youthful manhood. Both of them stood over six feet in the
long, soft, white leather boots which rose above their knees,
meeting their close-fitting, grey tunics of silk-embroidered
cloth, confined at the waist by belts curiously fashioned of
flat links of several different metals, and fastened in front by
heavy buckles of gold studded with great, flashing gems.</p>
<p class="calibre3">From their broad shoulders hung travelling-cloaks of fine,
blue cloth, lined with silver fur and kept in place across the
breast by silver chains and clasps of a strange, blue metal,
whose lustre seemed to come from within like that of a
diamond or a sapphire.</p>
<p class="calibre3">On their heads they wore no other covering than their
own thick, curling hair, which they wore somewhat in the
picturesque style of the fourteenth century, and a plain, broad
band of the gleaming blue metal, from which rose above the
temples a pair of marvellously-chased, golden wings about four
inches high—the insignia of the Empire of the Air, and the<span id="pgepubid00051" title="[40]"><a id="Page_40" title="[40]"></a></span>
sign which distinguished the Aerians from all the other peoples
of the earth.</p>
<p class="calibre3">As Olga shook hands with Alan, she looked up into his
dark-blue eyes, with a glance such as he had never received
from a woman before—a glance in which he seemed instinctively
to read at once love and hate, frank admiration and
equally undisguised defiance. Their eyes held each other
for a moment of mutual fascination which neither could
resist, and then the dark-fringed lids fell over hers, and a
faint flush rose to her cheeks as she replied to his words of
salutation—</p>
<p class="calibre3">“Surely the pleasure will rather be on our side, with
travelling companions from the other world! For my own
part, I seem to remind myself somewhat of one of the
daughters of men whom the Sons of the Gods”—</p>
<p class="calibre3">She stopped short in the middle of her daring speech, and
looked up at him again as much as to say—</p>
<p class="calibre3">“So much for the present. Let the Fates finish it!”
and then, appearing to correct <a id="Ref_40"></a>herself, she went on, with a
half-saucy, half-deprecating smile on her dangerously-mobile
lips—</p>
<p class="calibre3">“You know what I mean; not exactly that, but something
of the sort.”</p>
<p class="calibre3">“More true, I fancy, of the daughter of men than of the
supposed Sons of the Gods,” retorted Alan, with a laugh, half
startled by her words, and wholly charmed by the indescribable
fascination of the way in which she said them; “for the
daughters of men were so fair that the Sons of the Gods lost
heaven itself for their sakes.”</p>
<p class="calibre3">“Even so!” said Olga, looking him full in the eyes, and at
that moment the signal sounded for them to take their places
in the cars.</p>
<p class="calibre3">A couple of minutes after they had taken their seats, the
train drew out of the station with an imperceptible, gliding
motion, so smooth and frictionless that it seemed rather as
though the people standing on the platform were sliding backwards
than that the train was moving forward. The speed<span id="pgepubid00052" title="[41]"><a id="Page_41" title="[41]"></a></span>
increased rapidly, but so evenly that, almost before they
were well aware of it, the passengers were flying over the
snow-covered landscape, under the bright, heatless sun and
pale, steel-blue sky of a perfect winter’s morning, at a
hundred miles an hour, the speed ever increasing as they sped
onward.</p>
<p class="calibre3">The line followed the general direction of the present route
to Dover, which was reached in about half an hour. Without
pausing for a moment in its rapid flight, the express swept out
from the land over the Channel Bridge, which spanned the
Straits from Dover to Calais at a height of 200 feet above the
water.</p>
<p class="calibre3">Travelling at a speed of three miles a minute, seven minutes
sufficed for the express to leap, as it were, from land to land.
As they swept along in mid-air over the waves, Olga pointed
down to them and said to Alan, who was sitting in the armchair
next her own—</p>
<p class="calibre3">“Imagine the time when people had to take a couple of
hours getting across here in a little, dirty, smoky steamboat,
mingling their sorrows and their sea-sickness in one common
misery! I really think this Channel Bridge is worthy even of
your admiration. Come now, you have not admired anything
yet”—</p>
<p class="calibre3">“Pardon me,” said Alan, with a look and a laugh that set
Serge’s teeth gritting against each other, and brought the ready
blood to Olga’s cheeks; “on the contrary, I have been absorbed
in admiration ever since we started.”</p>
<p class="calibre3">“But not apparently of our engineering triumphs,” replied
Olga frankly, taking the compliment to herself, and seeming in
no way displeased with it. “It would seem that the polite art
of flattery is studied to some purpose in Aeria.”</p>
<p class="calibre3">“There you are quite wrong,” returned Alan, still speaking
in the same half-jocular, half-serious vein. “Before all things,
we Aerians are taught to tell the absolute truth under all
circumstances, no matter whether it pleases or offends; so, you
see, what is usually known as flattery could hardly be one of
our arts, since, as often as not, it is a lie told in the guise of<span id="pgepubid00053" title="[42]"><a id="Page_42" title="[42]"></a></span>
truth, for the sake of serving some hidden and perhaps dishonest
end.”</p>
<p class="calibre3">The blow so unconsciously delivered struck straight home,
and the flush died from Olga’s cheek, leaving her for the moment
so white that her companion anxiously asked if she was unwell.</p>
<p class="calibre3">“No,” she said, recovering her self-possession under the
impulse of sudden anger at the weakness she had betrayed.
“It is nothing. This is the first time for a year or so that I
have travelled by one of these very fast trains, and the speed
made me a little giddy just for the instant. I am quite well,
really, so please go on.</p>
<p class="calibre3">“You know, that wonderful fairyland of yours is a subject
of everlasting interest and curiosity to us poor outsiders who
are denied a glimpse of its glories, and it is so very rarely that
one of us enjoys the privilege that is mine just now, that I hope
you will indulge my feminine curiosity as far as your good
nature is able to temper your reserve.”</p>
<p class="calibre3">As she uttered her request, Alan’s smiling face suddenly
became grave almost to sternness. The laughing light died out
of his eyes, and she saw them darken in a fashion that at once
convinced her that she had begun by making a serious mistake.</p>
<p class="calibre3">He looked up at her, with a shadow in his eyes and a slight
frown on his brow. He spoke slowly and steadily, but with a
manifest reluctance which he seemed to take little or no
trouble to conceal.</p>
<p class="calibre3">“I am sorry that you have asked me to talk on what is a
forbidden subject to every Aerian, save when he is speaking with
one of his own nation. I see you have been looking at these
two golden wings on the band round my head. I will tell you
what they mean, and then you will understand why I cannot
say all that I know you would like me to say.</p>
<p class="calibre3">“They are to us what the toga virilis was to the Romans of
old, the insignia of manhood and responsibility. When a youth
of Aeria reaches the age of twenty he is entitled to wear these
wings as a sign that he is invested with all the rights and duties
of a citizen of the nation which has conquered and commands
the Empire of the Air.</p>
<p class="calibre3"><span id="pgepubid00054" title="[43]"><a id="Page_43" title="[43]"></a></span></p>
<p class="calibre3">“One of these duties is, that in all the more serious relations
of life he shall remain apart from all the peoples of the world
save his own, and shall say nothing that will do anything to
lift the veil which it has pleased our forefathers in their wisdom
to draw round the realm of Aeria. Before we assume the
citizenship of which these wings are the symbol we never visit
the outside world save to make air voyages, for the purpose of
learning the physical facts of the earth’s shape and the
geography of land and sea.</p>
<p class="calibre3">“Immediately after we have assumed it we do as Alexis and
I are now doing—travel for a year or so through the different
countries of the outside world, in order to get our knowledge of
men and things as they exist beyond the limits of our own
country.</p>
<p class="calibre3">“The fact that we do so,—under a pledge solemnly and
publicly given, of never revealing anything which could lead
even to a possibility of other peoples of the earth overtaking us
in the progress which we have made in the arts and sciences,—is
my excuse for refusing to tell you what your very natural
curiosity has asked.”</p>
<p class="calibre3">Olga saw instantly that she had struck a false note, and
was not slow to make good her mistake. She laid her hand
upon his arm, with that pretty gesture which Serge knew so
well, and watched now with much bitter feelings, and said, in a
tone that betrayed no trace of the consuming passion within
her—</p>
<p class="calibre3">“Forgive me! Of course, you will see that I did not know
I was trenching on forbidden grounds. I can well understand
why such secrets as yours must be, should be kept. You have
been masters of the world for more than a century, and even
now, although you have formally abdicated the throne of the
world, it would be absurd to deny that you still hold the destinies
of humanity in your hands.</p>
<p class="calibre3">“The secrets which guard so tremendous a power as that
may well be religiously kept and held more sacred than
anything else on earth. Still, you have mistaken me if you
thought I asked for any of these. All I really wanted was, that<span id="pgepubid00055" title="[44]"><a id="Page_44" title="[44]"></a></span>
you should tell me something that would give me just a
glimpse of what human life is like in that enchanted land of
yours”—</p>
<p class="calibre3">Alan laid his hands upon hers, which was still resting
upon his arm, and interrupted her even more earnestly than
before.</p>
<p class="calibre3">“Even that I cannot tell you. With us, the man who gives
a pledge and breaks it, even in the spirit though not in the
letter, is not considered worthy to live, and therefore I must be
silent.”</p>
<p class="calibre3">Instead of answering with her lips, Olga turned her hand
palm upwards, and clasped his with a pressure which he returned
before he very well knew what he was doing; and while the
magic of her clasp was still stealing along his nerves, Serge
broke in, with a harsh ring in his voice—</p>
<p class="calibre3">“But pardon me for interrupting what seems a very pleasant
conversation with my—my sister, I should like to ask, with all
due deference to the infinitely superior wisdom of the rulers of
Aeria, whether it is not rather a risky thing for you to travel
thus about the world, possessing secrets which any man or
woman would almost be willing to die even to know for a few
minutes, when, after all, you are but human even as the rest of
humanity are?</p>
<p class="calibre3">“You, for instance, are only two among millions; how
would you protect yourselves against the superior force
of numbers? Supposing you were taken unawares under
circumstances which make your superior knowledge unavailing.
You know, human nature is the same yesterday,
to-day, and to-morrow, despite the superficial varnish of
civilisation.</p>
<p class="calibre3">“The passions of men are only curbed, not dead. There
may be men on earth to-day who, to gain such knowledge as you
possess, would even resort to the tortures used by the Inquisition
in the sixteenth century. Suppose you found yourself in the
power of such men as that, what then? Would you still preserve
your secret intact, do you think?”</p>
<p class="calibre3">Alan heard him to the end without moving a muscle of his<span id="pgepubid00056" title="[45]"><a id="Page_45" title="[45]"></a></span>
face, and without even withdrawing his hand from Olga’s clasp.
But at the last sentence he snatched it suddenly away, half-turned
in his seat, and faced him. Then, looking him straight
in the eyes, he said in a tone as cold and measured as
might have been used by a judge sentencing a criminal to
death—</p>
<p class="calibre3">“We do not fear anything of the sort, simply because each
one of us holds the power of life and death in his hands. If
you laid a hand on me now in anger, or with an intent to do me
harm, you would be struck dead before you could raise a finger
in your own defence.</p>
<p class="calibre3">“Do you think that we, who are as far in advance of you
as you are in advance of the men of a hundred years ago, would
trust ourselves amongst those who might be our enemies were
we not amply protected against you? Tell me, have you ever
read a book, written nearly two hundred years ago in the
Victorian Age, called <cite class="calibre14">The Coming Race</cite>?”</p>
<p class="calibre3">“Yes,” said Serge, thinking, as he spoke, of the possibilities
contained in the secret will of Paul Romanoff, “I have read it,
and so has Olga. What of it?”</p>
<p class="calibre3">“Well,” said Alan quietly, without moving his eyes from
those of Serge. “I had better tell you at once that we have
realised, to all intents and purposes, the dream that Lytton
dreamt when he wrote that book. I can tell you so much
without breaking the pledge of which I have spoken. All that
the Vril-Ya did in his dream we have accomplished in reality,
and more than that.</p>
<p class="calibre3">“Our empire is not bounded by the roofs of subterranean
caverns, but only by the limits of the planet’s atmosphere.
We can soar beyond the clouds and dive beneath the seas.
We have realised what he called the Vril force as a sober,
scientific fact; and if I thought that you, for instance, were
my enemy, I could strike you dead without so much as
laying a hand on you. And if a dozen like you tried to overcome
me by superior brute force, they would all meet with the
same fate.</p>
<p class="calibre3">“I’m afraid this sounds somewhat like boasting,” he continued<span id="pgepubid00057" title="[46]"><a id="Page_46" title="[46]"></a></span>
in a more gentle tone, and dropping his eyes to the floor
of the car, “but the turn the conversation has taken obliged me
to say what I have done. Suppose we give it another turn and
change the subject. We have unintentionally got upon rather
uncomfortable ground.”</p>
<p class="calibre3">Serge and Olga were not slow to take the pointed hint, and
<a id="Ref_46"></a>so the talk drifted into general and more harmless channels.</p>
<div class="figcenter3">
<img alt="" class="calibre13" id="id-8494228477001041222" src="Images/img0006.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0009.vue?611194fa